import styled from 'styled-components';

import { Link } from 'react-router-dom';


const Boton = styled(Link)`
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    background-color:${(props) => (props.convocatoria ? "#EE805D" : props.bonificados ? "#003c66" : props.normal ? "#ffffff" : "black")};
    border: 1px solid ${(props) => (props.convocatoria ? "#EE805D" : props.bonificados ? "#003c66" : "black")};
    font-weight: 500;
    display: inline-block;
    line-height: 1;
    font-family: 'Roboto', sans-serif;
    border-radius: 3px;
    color:white;
    text-align: center;
    text-decoration: none;
    padding: 12px 18px 12px 18px;
    
    
    
    margin: 5%;

    font-size: ${(props) => (props.grande ? "20px" : "18px")};
    margin-left: 1% ;
    cursor: pointer;
	transition: .3s ease all;


    /* @media (max-width: 1150px) {
        margin-left: ${(props) => (props.alineado ? "20%" : "")};
    }

    @media (max-width: 2150px) {
        margin-left: ${(props) => (props.alineado ? "40%" : "")};
    } */

    
    &:hover {
		background-color:white;
        color: ${(props) => (props.convocatoria ? "#EE805D" : props.bonificados ? "#003c66" : "black")};
        border: 1px solid ${(props) => (props.convocatoria ? "#EE805D" : props.bonificados ? "#003c66" : "black")};
        
	}
 
    
`;

export default Boton;